import { FormControl, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";

const MonthYearInput = React.forwardRef(({
    control,
    name,
    label,
    defaultValue = "",
    rules,
    variant = 'outlined',
    margin = 'dense',
    disabled = false,
    readOnly = false,
    onChange,
    ...props
}, ref) => {
    const [formattedDate, setFormattedDate] = useState(defaultValue); // Holds the formatted yyyy-MM

    useEffect(() => {

        setFormattedDate(defaultValue); // Sync with defaultValue on mount
    }, [defaultValue]);

    const handleDateChange = (e, field) => {
        const value = e.target.value; // Example: "2025-04"
        setFormattedDate(value);      // Update local state

        field.onChange(value);        // Update react-hook-form state
        if (onChange) onChange(value); // Custom onChange handler
    };

    return (
        <FormControl fullWidth variant={variant} margin={margin}>
            <Controller
                {...props}
                name={name}
                control={control}
                rules={rules}
                defaultValue={defaultValue}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        label={label}
                        type="month" // Allows month/year selection
                        variant={variant}
                        margin={margin}
                        InputLabelProps={{ shrink: true }}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        inputRef={ref}
                        fullWidth
                        disabled={disabled}
                        inputProps={{
                            pattern: '[0-9]{4}-[0-9]{2}', // yyyy-MM pattern
                            readOnly: readOnly,
                        }}
                        value={formattedDate || ""} // Display formatted date
                        onChange={(e) => handleDateChange(e, field)}
                    />
                )}
            />
        </FormControl>
    );
});

export default MonthYearInput;
